import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import StoreBadges from '@/components/StoreBadges/StoreBadges';

import './HuntClaimPage.css';

/**
 * Where a phone camera lands after scanning a hunt item's claim note
 * (/hunt/claim/:itemId). Claiming only happens inside the app, so this page
 * tells the player how to do that and links to both stores.
 *
 * It reads nothing from the link: the page is the same for every item, so it
 * can't give away anything about one. The claim code sits after the # in the
 * link and never reaches this page or the server anyway (see #1088).
 */
const HuntClaimPage = () => (
    <section id="hunt-claim" className="py-5 bg-light">
        <Container>
            <Row className="justify-content-center">
                <Col md={10} lg={8} className="hunt-claim-content text-center">
                    <h1 className="text-primary mb-4">
                        You found a hunt item!
                    </h1>
                    <p className="fs-5">
                        {
                            "To claim it, open the Roadrunner Connect app, go to the hunt, and scan this note's QR code from the item's claim screen."
                        }
                    </p>
                    <p>
                        {
                            "Don't have the app yet? Download it, sign in, join the hunt, then scan the note again."
                        }
                    </p>
                    <StoreBadges className="mt-4" />
                </Col>
            </Row>
        </Container>
    </section>
);

export default HuntClaimPage;
